// extracted by mini-css-extract-plugin
export default {"Drawer":"eujhXIu0","ContentRoot":"ojoMmoLL"};